import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatDetailModalComponent } from './chat-detail-modal/chat-detail-modal.component'
import { ScrollbarModule } from 'ngx-scrollbar'
import { FormsModule } from '@angular/forms'
import { CommonsModule } from '@commons/commons.module'
import { ChatModule } from '@commons/chat/chat.module'
import { ChatFrameComponent } from './chat-frame/chat-frame.component'

const CHILD = [
    ChatDetailModalComponent,
    ChatFrameComponent,
]

@NgModule({
    imports: [
        CommonModule,
        ScrollbarModule,
        FormsModule,
        CommonsModule,
        ChatModule,
    ],
    declarations: [...CHILD],
    exports: [...CHILD],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalCommonsModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/modal-commons/modal-commons.module.ts